import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'th0017',
    ecrans: ['00-2']
});
